import { Requisition } from './requisition';

export class ContractRequisition {
  id: number;
  company_id: number;
  contract_id: number;
  // name: string;
  // contact: string;
  nit: string;
  // address: string;
  // city: string;
  // country: string;
  // location: string;
  email: string;
  phone: string;
  // web: string;
  // industry: string;
  legalrep_name: string;
  // legalrep_idtype: string;
  // legalrep_idnumber: string;
  // company_infocol: string;
  legalname: string;
  // taxid: string;
  // legal_address: string;
  // // legal_city: string;
  // legal_country: string;
  // industry_id: number;
  // services: string;
  // clients: string;
  // moreinfo: string;
  requisitions: Requisition[];
  // amount: number;
  contact_name: string;
  contact_phone: string;
  contact_email: string;
}



// WEBPACK FOOTER //
// /Users/everis/code/Dj/front.staff/src/app/models/contractRequisition.ts